module.exports = __webpack_public_path__ + "static/media/Halal.9ad5997b.jpg";